import * as EmailValidator from 'email-validator';

export const validatePassword = (password, confirm) => {
    if (password === null || password.length < 6) {
        return false;
    }

    if (typeof confirm !== 'undefined') {
        return password === confirm;
    }

    return true
}

export const validateEmail = email => EmailValidator.validate(email);

export const validateUrl = url => /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(url);
